import React from 'react'
import "./modal-body.css";


export default function ModalBody() {
  return (
    <div>
      <div className="accordion" id="accordionExample">
        <div className="card">
          <div className="card-header" id="headingOne">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              ضخامت دوده سخت
              </button>
            </h2>
          </div>

          <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"> </span>ضخامت دوده سخت (Soot Thickening): احتراق ناقص سوخت میتواند منجر به تشکیل ذرات ریز و سخت کربنی در جداره محفظه احتراق شود که به آن دوده سخت گفته میشود. به دلیل متفاوت بودن سوخت و نوع احتراق، تشکیل دوده سخت در موتورهای دیزلی بیشتر از موتورهای بنزینی اتفاق می افتد. افزایش ضخامت دوده سخت، باعث افزایش گرانروی روانکار و تبع آن سائیدگی موتور خواهد شد.
در موارد بحرانی انباشت بیش از اندازه دوده سخت و جدا شدن به یکباره آنها، میتواند مجرای عبور روغن و یا فیلترها را مسدود نموده و از رسیدن روانکار به همه سطوح مورد نیاز جلوگیری نماید. عمدتا پراکنده کننده ها (مواد حلال) موجود در روغن از ضخیم شدن دوده سخت  جلوگیری مینماید.


              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingTwo">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                سائیدگی
              </button>
            </h2>
          </div>
          <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span>  سائیدگی (Wear): یکی از وظایف اصلی روانکار، کاهش و یا جلوگیری از سائیدگی قطعات متحرک موتور میباشد. افزایش میزان سائیدگی میتواند به کاهش راندمان و حتی توقف عملکرد موتور منجر شود.
Zinc Dialkyl Dithio Phosphates (ZDDPs) موجود در روانکارها موجب کاهش و کنترل سائیدگی در موتور میگردد.  

              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingThree">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                رسوبات پیستون
              </button>
            </h2>
          </div>
          <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span>رسوبات پیستون ( Piston Diposits): دمای محفظه احتراق موتور در هنگام کار به بیش از چند صد درجه سانتیگراد میرسد که این امر منجر به شکل گیری واکنشهای شیمیائی متعددی میگردد. این واکنشها رسوباتی را در داخل یا اطراف پیستون ایجاد مینماید. عدم کنترل و کاهش رسوبات به وجود آمده در پیستون منجر به انتقال یافتن گازهای داغ حاصل از احتراق به کارتر و افزایش بیش از اندازه دما و کاهش شدید کارایی روانکار گردید که این معضل موجب ایجاد صدمات جبران ناپذیر به موتور میشود.
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingFour">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                غلظت سوختگی
              </button>
            </h2>
          </div>
          <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span> غلظت سوختگی (Oxidative Thikening): روغن موتور در هنگام کارکرد موتور در معرض دمای زیاد قرار میگیرد که منجر به شکل گیری واکنش اکسیداسیون (سوختن) روغن در محفظه احتراق میگردد. اگر روغن در برابر اکسیداسیون مقاومت نداشته باشد (اکسید شود)، ویسکوزیته اش افزایش یافته و حتی تا حدی غلیظ و ویسکوز میگردد که پمپ روغن توانایی پمپ کردن آن را نداشته و منجر به صدمه موتور میگردد. آنتی اکسیدان های موجود در روغن موتور عمدتا وظیفه کنترل میزان سوختگی روغن را بر عهده دارند.
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingFive">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                صرفه جویی در مصرف سوخت
              </button>
            </h2>
          </div>
          <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span> صرفه جویی در مصرف سوخت (Fuel Economy): برای کاهش انتشار دی اکسید کربن، روغن موتور باید صرفه جویی در مصرف سوخت بیشتری را به همراه داشته باشد. برای دستیابی به مصرف سوخت کمتر، روغن موتور باید در دمای 150 درجه سانتیگراد ویسکوزیته ای کمتر از 3.5 سانتی پواز داشته باشد (HTHS viscosity &lt; 3.5cP) و در تولید آن از افزودنیهای بهبود دهنده اصطکاک استفاده شده باشد. 
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingSix">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
              سازگاری با سیستم پایش پایانی
              </button>
            </h2>
          </div>
          <div id="collapseSix" className="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span> سازگاری با سیستم پایش پایانی (Aftertreatment Compatibility): برای رعایت استانداردهای آلایندگی، تولید کنندگان موتورهای وسایل نقلیه از سیستم پایش پایانی استفاده میکنند.
این سیستم میتواند توسط گازهای خروجی که حاوی اجزای آلاینده ( مواد تشکیل دهنده روانکار که طی فرایند احتراق تبدیل به مواد بسیار آلاینده میشوند) میباشد، تحت تاثیر منفی قرار بگیرد. برای سازگاری با سیستم پایش پایانی، حداکثر میزان مجاز مواد قابل استفاده در ساخت روغن موتور که منجر به تولید آلاینده ها میشوند، تعیین شده است. 
کاهش اجزایی مانند سولفور و فسفر و سایر مواد شیمیایی که منجر به افزایش خاکسترهای گوگردی میشود میتواند سازگاری روغن موتورها را با سیستم پایش پایانی بهبود دهد.

              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingSeven">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
              لجن 
              </button>
            </h2>
          </div>
          <div id="collapseSeven" className="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span> لجن (Sludge): احتراق ناقص سوخت بنزینی و اکسید شدن روانکار میتواند منجر به قطبی و مجتمع شدن ذرات در روغن موتور شود که به آن لجن میگویند. لجن میتواند فیلترها و مجراهای باریک داخلی روغن را در موتور مسدود نماید که این امر موجب کاهش حجم روغن رسانی و افت راندمان عملکرد روانکار میگردد. وظیفه کنترل لجن در روغن موتور به عهده حلالهای افزودنی به نام پراکنده کننده میباشد
              </div>
            </div>
          </div>
        </div>



        <div className="card">
          <div className="card-header" id="headingSs">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#headingS" aria-expanded="false" aria-controls="headingS">
              توضیحات کوتاه در رابطه با دستورالعمل ها
              </button>
            </h2>
          </div>
          <div id="headingS" className="collapse" aria-labelledby="headingSs" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span> <p>جدول خصوصیات و نمودار راداری مقایسه کارایی این صفحه حاوی خصوصیات فیزیکی و معمول روانکارها ( مانند VI-V@40-V@100-PP-FP-... ) که در تمامی کاتالوگها و دیتا شیتهای روانکارهای مختلف قید شده است نمیباشد و صرفا بر راندمان یا خصوصیات شیمیائی این روغنها تمرکز دارد. در این جدول و نمودار سعی شده است که اطلاعات نایاب و همگن شده ای که در سایر سایتهای مرتبط نمیتوان یافت را جهت مقایسه و آشنایی بیشتر در اختیار شما قرار دهیم. برای استفاده ابتدا باید استاندارد یا اپرووال مد نظر خود را از منوی سمت چپ، انتخاب صفحه کنید.</p> 
<p>توجه 1: اطلاعات مندرج در نمودار راداری، صرفا به منظور مقایسۀ کارایی استانداردها و اپرووالها روغن موتور ها با یکدیگر تهیه شده است. بنابراین استفاده از دو استاندارد یا اپرووال با کارایی یکسان و مشابه به جای یکدیگر، با استناد به این نمودار مجاز نبوده و حتما مطابق با دستورالعمل پیشنهادی تولید کننده وسیله نقلیه خود اقدام به خرید و استفاده روغن موتور نمائید.</p>
              <p>توجه 2: نمودار راداری موجود به منظور مقایسه استانداردها با کلاس مشترک تنظیم شده است. به طور مثال مقایسه ACEA E6 با ACEA E7 یا API CH-4 با API CJ-4.</p>
              <p>علی رغم امکان پذیر بودن، مقایسه استانداردها در کلاسهای صنعتی مختلف با هم ممکن است نتایج غیر دقیقی به همراه داشته باشد.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingTw">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTw" aria-expanded="false" aria-controls="collapseTw">
              راهنمای جدول مقایسه ای
              </button>
            </h2>
          </div>
          <div id="collapseTw" className="collapse" aria-labelledby="headingTw" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span> 

                <table>
                    <tbody>
                      <tr>
                        <td className="keyTerm">Key</td>
                        <td className="keyTerm">Definition (تعریف مقادیر)</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">
                          HTHS&nbsp;&nbsp;&nbsp;&nbsp;
                        </td>
                        <td>Viscosity at high temperature and shear(cP)</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">SA</td>
                        <td>Sulphated Ash (%)</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">P</td>
                        <td>Phospherus (%)</td>
                      </tr>
                      <tr>
                        <td className="keyTerm">S</td>
                        <td>Sulphur (%)</td>
                      </tr>
                    </tbody>
                  </table>


              </div>
            </div>
          </div>
        </div>






      </div>
    </div>
  )
}
